
export const IMG_URL = 'https://firebasestorage.googleapis.com/v0/b/bnksistemimobile.appspot.com/o/images%2Fproduct_default_img.png?alt=media&token=80beb9f8-2416-449d-b4c3-9d594445e02f';

export const URL_LOCALHOST = "http://localhost:3000";

export const BNK_URL = "http://localhost:3000";




